import React from "react"
import { compose, withProps, withHandlers, defaultProps } from "recompact"
import { InputNumber } from "@infotech/uikit-input"
import moment from "moment"
import { Box } from "@infotech/uikit-grid"
import styles from "./styles.css"

const DAYS = `days`
const HOURS = `hours`
const MINUTES = `minutes`

// Expects value to be in seconds
const createTimeChangeHandler = timeUnit => ({
  input,
  onChange: onChangeProp,
  value: valueProp,
  makeShowErrors,
}) => event => {
  const onChange = onChangeProp || (input && input.onChange)
  const value = valueProp || (input && input.value)
  let newNumberOfUnits = event.target ? event.target.value : event
  if (newNumberOfUnits > 9999 && timeUnit === DAYS) {
    newNumberOfUnits = 9999
  }
  if (newNumberOfUnits > 23 && timeUnit === HOURS) {
    newNumberOfUnits = 23
  }
  if (newNumberOfUnits > 59 && timeUnit === MINUTES) {
    newNumberOfUnits = 59
  }

  const seconds = typeof value === `number` ? value : 0
  const duration = moment.duration(seconds * 1000)
  const oldNumberOfUnits =
    timeUnit === DAYS ? Math.floor(seconds / 86400) : duration[timeUnit]()
  const delta = parseInt(newNumberOfUnits || 0, 10) - oldNumberOfUnits
  const newSeconds = duration.add({ [timeUnit]: delta }).asSeconds()
  onChange(newSeconds || null)
  makeShowErrors(false)
}

const createTimeUnitProp = (value, timeUnit) => {
  if (typeof value === `number`) {
    const result =
      timeUnit === DAYS
        ? Math.floor(value / 86400).toString()
        : moment
            .duration(value * 1000)
            [timeUnit]()
            .toString()
    if (result === `0`) {
      return ``
    }
    return result
  }
  return ``
}

export default compose(
  defaultProps({
    meta: {},
  }),
  withProps(({ input, value }) => ({
    days: createTimeUnitProp((input && input.value) || value, DAYS),
    hours: createTimeUnitProp((input && input.value) || value, HOURS),
    minutes: createTimeUnitProp((input && input.value) || value, MINUTES),
  })),
  withHandlers({
    onChangeDays: createTimeChangeHandler(DAYS),
    onChangeHours: createTimeChangeHandler(HOURS),
    onChangeMinutes: createTimeChangeHandler(MINUTES),
  }),
)(
  ({
    days,
    hours,
    minutes,
    onChangeDays,
    onChangeHours,
    onChangeMinutes,
    meta: { valid },
    error,
    getTestAttribute,
    isHoursDisabled,
    isMinutesDisabled,
    isDisabled = false,
  }) => (
    <div>
      <Box loose flex pb={error ? `0` : `1md`}>
        <Box loose flex className={styles.time}>
          <div data-testid={getTestAttribute(`days`)}>
            <InputNumber
              value={days === `0` ? `` : days}
              onChange={onChangeDays}
              disabled={isDisabled}
              placeholder="Дни"
              valid={valid}
              className={styles[`leftmost-input`]}
              maxlength={4}
            />
          </div>
        </Box>
        <Box loose flex className={styles.time}>
          <div data-testid={getTestAttribute(`hours`)}>
            <InputNumber
              value={hours === `0` ? `` : hours}
              onChange={onChangeHours}
              disabled={isHoursDisabled || isDisabled}
              placeholder="Часы"
              valid={valid}
              maxlength={2}
            />
          </div>
        </Box>
        <Box loose flex className={styles.time}>
          <div data-testid={getTestAttribute(`minutes`)}>
            <InputNumber
              value={minutes === `0` ? `` : minutes}
              onChange={onChangeMinutes}
              disabled={isMinutesDisabled || isDisabled}
              placeholder="Минуты"
              valid={valid}
              maxlength={2}
            />
          </div>
        </Box>
      </Box>
      {error && <div className={styles[`input-error`]}>{error}</div>}
    </div>
  ),
)
